const swiper = new Swiper('.r-screenshots', {
  slidesPerView: 3,
  spaceBetween: 16,
  centeredSlides: true,
  loop: true,
  breakpoints: {
    320: {
      slidesPerView: 1
    },
    768: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3
    }
  },
  navigation: {
    nextEl: ".button-next",
    prevEl: ".button-prev",
  },
  pagination: {
    el: ".control-pagination",
    clickable: true,
  },
});

const swiper2 = new Swiper('.r-screenshots-less-than-three', {
  slidesPerView: 'auto',
  centeredSlides: true,
})


const screenshotsSwiperThumbs = document.querySelector('.r-screenshots-swiper-thumbs')
 screenshotsSwiperThumbs.addEventListener('click', function (e) {
    if(e.target.tagName === 'IMG') {
      createPopup(e.target.outerHTML)
    }
 })


function createPopup(image) {

  const overlay = document.createElement('div')
  const popup = document.createElement('div')
  overlay.classList.add('thumb-overlay')
  popup.classList.add('thumb-popup')
  popup.innerHTML = `<button class = "close-popup"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg></button><div class="thumb">${image}</div>`
  document.body.append(overlay)
  document.body.append(popup)

  const closePopup = popup.querySelector('.close-popup')
  closePopup.addEventListener('click', (e) => {
    removePopup(popup, overlay)
  })

}

function removePopup(popup, overlay) {
  popup.remove()
  overlay.remove()
}